import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { EnrollmentFlowScreenProps } from "../../types/components";
import useWindowDimensions from "../../services/useWindowDimensions";
import { RootState } from "../../types/redux";
import { useSelector } from "react-redux";

import ActionLink from "../Common/ActionLink";
import PrintPage from "../Common/PrintPage";
import Pagestepper from "../Enrollment/PageStepper";
import DynamicModal from "../Common/DynamicModal";
import InfoTip from "../Common/InfoTip";
import ProgressBar from "../Enrollment/ProgressBar";
import { ENROLLMENT_PAGES } from "../../constants/enrollment";
import BackAction from "../Common/BackAction";
import { Action } from "../Common/Action";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";

const EnrollmentFlowScreen = ({ flowTitle, showBackButton, customBackButtonFunc, showPrintPage, className, testId, children }: EnrollmentFlowScreenProps) => {
  const history = useHistory();
  const currentPage = useSelector((state: RootState) => state.enrollment.currentPage);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { width } = useWindowDimensions();

  useEffect(() => {
    // Reset the form and scroll to the top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []);

  const handleBackClick = () => {
    if (customBackButtonFunc) {
      customBackButtonFunc();
    } else {
      history.goBack();
    }
  }

  const pageTitle = `(${ENROLLMENT_PAGES.find(page => page.page_number === currentPage)?.page_number_display}/6)`;

  return (
    <div className="flex-row">

      <ProgressBar currentPage={currentPage} />

      {width > 768

        ? <Pagestepper currentPage={currentPage} />
        : <DynamicModal
          className="v2 v3"
          open={isModalOpen}
          setClose={() => setIsModalOpen(false)}
          showCloseIcon={false}
          body={<>
            <h2 className="abyss-blue bold text-size-lg text-left spacing-bottom-none">Enrollment Steps</h2>
            <Pagestepper currentPage={currentPage} className="spacing-top-small" />
          </>}
          footer={
            <Action
              title="Close"
              displayType={ACTION_DISPLAY_TYPES.TEXT}
              onClick={() => setIsModalOpen(false)}
              className="w-full"
            />
          }
        />
      }

      <div className={`${width > 768 ? 'flow-page-block w-full' : ""}`}>
        <div className={`v2 v3 flow-screen ${className || ''}`} data-testid={testId || "enrollment-flow-screen"}>
          {(showBackButton || showPrintPage) &&
            <div className="flex-row justify-content-between align-items-center">
              {showBackButton &&
                <BackAction
                  onClick={handleBackClick}
                />
              }
              {showPrintPage &&
                <PrintPage />
              }
            </div>
          }
          <div className="relative flex-row justify-content-between align-items-center">
            <h1 className="flow-screen__header">
              {flowTitle} {" "}
              <span>{pageTitle}</span>
            </h1>

            {width < 768 &&
              <InfoTip onClick={() => setIsModalOpen(true)} />
            }
          </div>

          <div className={`${width < 768 ? "flow-page-block" : ""}`}>
            {children}
          </div>
        </div>
      </div>
    </div>

  );
};

export default EnrollmentFlowScreen;